import type { CronJobLogEnvironment } from "../models/admin-monitoring.models";

export const getDefaultAdminMonitoringEnvironment = (): CronJobLogEnvironment => {
  const hostname = typeof window === "undefined" ? "" : window.location.hostname.toLowerCase();
  if (hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1" || hostname === "[::1]") {
    return "DEV";
  }

  const deploymentEnvironment = process.env.REACT_APP_RUM_ENV?.trim().toLowerCase();

  if (deploymentEnvironment === "prod" || deploymentEnvironment === "prd" || deploymentEnvironment === "production") {
    return "PRD";
  }
  if (deploymentEnvironment === "stage" || deploymentEnvironment === "qas" || deploymentEnvironment === "qs") {
    return "QAS";
  }
  return "DEV";
};
